import WritePost from './WritePost';
export default WritePost;
